module.exports = __webpack_public_path__ + "img/capelo_logo_200_60.74dba44b.gif";